/** @format */

import colors from "@src/style/colors";

export const commonInfo = {
  btn: {
    image: "/img/icons/feature/menu.png"
  },
  logo: {
    sandbank: {
      image: "/img/icons/logo/sandbank_logo.svg"
    },
    surf: {
      image: "/img/pages/main/logo-surf.png"
    }
  },
  navbar: [
    {
      name: "SURF",
      url: "https://surf.sandbank.io"
    },
    {
      name: "COMPANY",
      url: "https://corp.sandbank.io/"
    },
    {
      name: "RECRUIT",
      url: "https://sandbank.oopy.io/?utm_source=Homepage&utm_medium=link&utm_campaign=recruit"
    }
  ],

  intro: {
    img: {
      phone_image: "/img/pages/main/intro_phone.png"
    }
  },
  partner: {
    title: "믿을 수 있는 기관 파트너들과 함께하는 샌드뱅크",
    items: [
      {
        name: "PRIMER",
        image: "/img/pages/main/partner_primer.png",
        url: "https://primer.kr"
      },
      {
        name: "STRONG VENTURES",
        image: "/img/pages/main/partner_strongVentures.png",
        url: "https://www.strongvc.com"
      },
      {
        name: "KICA",
        image: "/img/pages/main/partner_kica.png",
        url: "https://www.kica.co.kr/kica/main/formMain.sg"
      },
      {
        name: "GOOGLE FOR STARTUP",
        image: "/img/pages/main/partner_google.png",
        url: "https://www.campus.co/intl/ko_kr/seoul/"
      },
      {
        name: "CHAINLINK",
        image: "/img/pages/main/partner_chainlink.png",
        url: "https://chain.link"
      },
      {
        name: "HAECHI LABS",
        image: "/img/pages/main/partner_haechi.png",
        url: "https://haechi.io"
      },
      {
        name: "HEXLANT",
        image: "/img/pages/main/partner_hexlant.png",
        url: "https://hexlant.com"
      }
    ]
  },
  strength: {
    title: {
      sm: "Your go-to service<br/>for all this and more",
      else: "Your go-to service for all this and more"
    },
    description:
      "We offer easy crypto asset management, a wide range of investment products, and invaluable insights from industry experts! Step into the future with us and experience the revolution of WEB 3.0 finance at Sandbank. We’re making investing more enjoyable and convenient than ever.",
    items: [
      {
        text: "안정적 수익",
        top: "",
        bottom: "",
        left: "",
        right: ""
      },
      {
        text: "자산 관리",
        top: "",
        bottom: "",
        left: "",
        right: ""
      },
      {
        text: "투자 인사이트",
        top: "",
        bottom: "",
        left: "",
        right: ""
      },
      {
        text: "철저한 보안",
        top: "",
        bottom: "",
        left: "",
        right: ""
      }
    ],
    img: {
      phone_image: "/img/pages/main/strength_phone.png"
    }
  },
  feature: [
    {
      id: 1,
      title: "Smart Asset Management",
      description:
        "Investing in crypto assets has become much more convenient now. With Sandbank, investors who have connected their exchange accounts and personal wallets can manage their dispersed assets in one location. Effortlessly view the total value of your portfolio and all transaction histories.",
      image: "/img/pages/main/feature_1.png"
    },
    // {
    //   id: 2,
    //   title: "Diverse<br />Investment Options",
    //   description:
    //     "Leverage cutting-edge strategies like algorithmic trading and PoS on-chain investing in the crypto market to steadily grow your crypto holdings with confidence.",
    //   image: "/img/pages/main/feature_2.png"
    // },
    {
      id: 3,
      title: "Exclusive Content<br />Rich in Insights",
      description:
        "Experience precise investment insights with our curated content selection. Don’t forget to subscribe to your favorite creators and stay notified.",
      image: "/img/pages/main/feature_3.png"
    }
    // {
    //   id: 4,
    //   title: "Enhanced Security<br />with Multi-Sig Wallet",
    //   description:
    //     "Private keys needed for withdrawal approvals are split and held individually by Sandbank and the 3rd-party custodian, providing a robust safeguard for your assets against hacking and security breaches.",
    //   image: "/img/pages/main/feature_4.png"
    // }
  ],
  value: {
    title: "Why Sandbank?",
    title_else: "Why Sandbank?",
    items: [
      {
        title: "Effortlessly Monitor<br />Your Crypto Investments",
        description:
          "Pondering your balance on a particular exchange or the price you paid for a certain asset? Sandbank streamlines investing by delivering clear, at-a-glance insights into your crypto portfolio, allowing you to concentrate on what's truly important.",
        img: "/img/pages/main/Value_1.jpg"
      },
      // {
      //   title: "Crypto potential maximized",
      //   description:
      //     "Unsatisfied with past trading results? Don't let your crypto sit idle. Sandbank's expert team offers diverse investment products for stable returns and optimized asset growth.",
      //   img: "/img/pages/main/Value_2.jpg"
      // },
      {
        title: "Premium content<br />for accurate insights",
        description:
          "Say goodbye to endless Telegram channels! Sandbank offers premium content for reliable insights without misleading info or ads. Experience the difference today!",
        img: "/img/pages/main/Value_3.jpg"
      }
      // {
      //   title: "Unparalleled security and<br /> Asset protection",
      //   description:
      //     "Enjoy peace of mind as we ensure zero theft or losses in asset management since inception. Rely on our steadfast dedication to financial security.",
      //   img: "/img/pages/main/Value_4.jpg"
      // }
    ]
  },
  message: {
    title: "Amid currency devaluation",
    subtitle: "crypto investment is a necessity, not a choice",
    subtitle_else: "crypto investment is a necessity, not a choice",
    description:
      "Discover the future of finance with Sandbank's unique services, different from traditional crypto markets.",
    text: "As crypto assets become essential stores of value in this digital transformation, experience the satisfaction of growing your wealth alongside our cutting-edge solutions.",
    text_else:
      "As crypto assets become essential stores of value in this digital transformation, experience the satisfaction of growing your wealth alongside our cutting-edge solutions."
  },

  growth: {
    title: "Built on trust, we continue<br /> to thrive and expand.",
    title_else: "Built on trust, we continue<br />  to thrive and expand."
  },

  review: {
    title: "User Review",
    items: [
      '"Absolutely loving the Sandbank app. It’s a game-changer for investments! 😊"',
      '"The returns on Sandbank have been consistently impressive. Couldn’t be happier! 👍"',
      '"The user interface on this app is top-notch. Makes investing a breeze."',
      '"Trustworthy and efficient. Sandbank has become my go-to app for crypto investing."',
      '"The stable returns on Sandbank are truly commendable. Highly recommend!"',
      '"Sandbank’s interface is so intuitive and user-friendly. I’m enjoying every bit of my investment journey. 💰"',
      '"Exceptional investment app. Sandbank has surpassed all my expectations!"',
      '"Trust and consistent returns, that’s what Sandbank offers. Great job, team!"'
    ]
  },

  security: {
    title:
      "Concerned about safety?<br />Rest assured, Sandbank has got you covered.",
    items: [
      {
        id: 1,
        bgColor: colors.coolGray,
        textColor: colors.white,
        iconColor: colors.white,
        image: "/img/pages/main/main_secure_1.png",
        title: "ISO/IEC 27001 Certification",
        title_else: "ISO/IEC 27001<br/>Certification",

        back_title: "ISO/IEC 27001 Certification",
        text: "ISO/IEC 27001 is an international standard that helps organizations manage the security of their information assets. Through this certification, we will enhance our credibility as a company that complies with the law and safely manages customers' valuable information assets.",
        list: ["Company - D.A.Ground", "Certification no. - ACT-IC-2157"],
        icon_front: "/img/icons/feature/icon_filp-light.png",
        icon_back: "/img/icons/feature/icon_filpback-light.png"
      },
      {
        id: 2,
        bgColor: colors.blue,
        textColor: colors.white,
        iconColor: colors.white,
        image: "/img/pages/main/main_secure_2.png",
        title: "Multi-sig wallet<br/>provided by Hexlant",
        title_else: "Multi-sig wallet<br/>provided by Hexlant",

        back_title: "Multi-sig wallet<br/>provided by Hexlant",
        text: "Sandbank has enforced a multisig protocol for asset protection in our wallets, requiring at least two out of three keys to authorize withdrawals, reducing the risk of unauthorized intrusions or errors. Additionally, Hexlant Octet’s Anti-Money Laundering system is utilized, blocking transactions from blacklisted addresses, lessening potential for money laundering. Sandbank is committed to superior financial security and integrity.",
        icon_front: "/img/icons/feature/icon_filp-light.png",
        icon_back: "/img/icons/feature/icon_filpback-light.png"
      },
      // {
      //   id: 3,
      //   bgColor: colors.white,
      //   textColor: colors.black,
      //   iconColor: colors.coolGray200,
      //   image: "/img/pages/main/main_secure_3.png",
      //   title: "Quarterly Financial<br/>Audit Reporting",
      //   title_else: "Quarterly Financial<br/>Audit Reporting",

      //   back_title: "Quarterly Financial<br/>Audit Reporting",
      //   text: "At Sandbank, we diligently conduct quarterly audits of our stored crypto assets in partnership with external accounting firms. The results of these audits are openly shared across various platforms, including our official website.<br/><br/>- 2022 Q3 Audit Report<br/>- 2022 Q4 Audit Report<br/><br/>Our commitment is to ensure asset security and uphold transparency, fostering trust in our services.",
      //   icon_front: "/img/icons/feature/icon_filp-dark.png",
      //   icon_back: "/img/icons/feature/icon_filpback-dark.png"
      // },
      {
        id: 4,
        bgColor: colors.coolGray500,
        textColor: colors.black,
        iconColor: colors.white,
        image: "/img/pages/main/main_secure_4.png",
        title: "Private Information Insurance",
        title_else: "Private Information Insurance",

        back_title: "Private Information Insurance",
        text: "We offer a system that safeguards against legal liabilities and potential damages in the event of unforeseen customer data breaches. This mechanism reduces the adverse impacts of such crises by requiring companies to either acquire insurance or build reserves as a safety net. Essentially, it’s an insurance policy that compensates for any financial losses incurred due to unexpected data leaks.",
        icon_front: "/img/icons/feature/icon_filp-light.png",
        icon_back: "/img/icons/feature/icon_filpback-light.png"
      }
    ]
  },
  page: {
    intro: {
      phone_image: "/img/pages/main/intro_phone.png"
    },
    strength: {
      phone_image: "/img/pages/main/strength_phone.png"
    }
  },

  qna: [
    {
      title: "What is Sandbank?",
      description:
        "Sandbank is a trailblazing platform for crypto asset management and investment. By leveraging open banking technology, we offer optimal asset management, a diverse range of investment products, and sophisticated portfolio analytics and recommendations. In 2023, we’ve launched Sandbank 2.0, an upgrade designed to enhance user experience, providing bespoke services that assist customers in optimizing their asset allocation, amplifying profitability, and managing risk."
    },
    {
      title: "What is WEB 3.0 finance and how does Sandbank incorporate it?",
      description:
        "WEB 3.0 finance signifies a novel financial paradigm, providing transparent and universally accessible services through blockchain technology. This innovative system aims to transition from traditional, centralized finance where institutions manage user assets, to a system where users directly manage their assets and conduct transactions swiftly and efficiently.<br/ ><br /> Sandbank is at the forefront of this WEB 3.0 financial revolution, providing users with a convenient platform to manage their diverse crypto wallets and investment products that offer stable profits beyond mere asset storage."
    },
    {
      title: "How can I manage my crypto asset on Sandbank?",
      description:
        "Sandbank allows for the swift integration of crypto asset portfolios scattered across user's exchanges and personal wallets. This integration facilitates tracking and analysis of asset flow and suggests optimal asset allocation. With compatibility with the top four Korean exchanges (Upbit, Bithumb, Coinone, Korbit), the globally renowned Binance exchange, and individual wallets like Metamask, Sandbank offers seamless integration within just 20 seconds."
    },
    // {
    //   title: "What types of investment products does Sandbank offer?",
    //   description:
    //     "At Sandbank, users can realize annual returns exceeding 10% through our quant trading strategy-based fixed income products (BTC, ETH, USDT, XRP). We also offer an array of investment options, including index-based passive products and PoS on-chain products, enabling users to tailor their investment portfolios to their preferences and needs."
    // },
    {
      title: "How do I create a Sandbank account?",
      description:
        "Registration is accessible via the Sandbank mobile app. Download the app from the Google Play Store or Apple App Store, and proceed with the sign-up process."
    },
    // {
    //   title: "How do I deposit funds into my Sandbank account?",
    //   description:
    //     "Crypto assets stored in an exchange or personal wallet can be deposited by transferring them to the wallet address created on your Sandbank account. For amounts under 1 million Korean won, instant deposits are possible through domestic exchanges (Upbit, Bithumb, Korbit, Coinone, and Gopax). For larger amounts, a transfer via an overseas exchange or personal wallet is required. To keep costs low during the deposit process, consider transferring low-fee assets like Ripple (XRP) or Tron (TRX) to overseas exchanges like Binance, then exchange for the desired asset."
    // },
    {
      title: "Are both website and mobile app available for Sandbank?",
      description:
        "Currently, we only support mobile app services, with web services set to launch in the second half of 2023."
    },
    {
      title: "Is there any subscription fee?",
      description:
        "Our service is completely free of charge. However, withdrawal fees for crypto assets may apply, which are fees paid to the blockchain network."
    },
    // {
    //   title: "How safe is Sandbank?",
    //   description:
    //     "Sandbank ensures the security of deposited assets from hacking or fraud using the wallet solution of VASP company, Hexlant. We operate with a risk management system based on automation, putting customer fund security first. With our high-level security and risk management measures, Sandbank has maintained a flawless record with no withdrawal failures or operational losses."
    // },
    {
      title: "Who can I contact if I have any issues or concerns?",
      description:
        "To use the customer center:<br /><br /> On the mobile app:  <br /> Select the [Customer Center] menu from [My Page] within the Sandbank app, and a ChannelTalk window will open. <br />Select [New Inquiry] → [1:1 Consultation Inquiry] to connect with a consultant. <br /><br /> On the website: <br /> Click the purple icon on the bottom right of the screen to open a ChannelTalk window.<br />Click the [New Inquiry] button → [1:1 Consultation Inquiry] to connect with a consultant."
    }
  ],
  appDownload: {
    title:
      "Don’t wait!<br/>Dive into the innovative world of<br/>WEB 3.0 finance with Sandbank today.",
    items: [
      {
        name: "GOOGLE PLAY",
        url: "https://sandbankapp.onelink.me/u9ZD/fb15e190",
        image: "/img/pages/main/google.png"
      },
      {
        name: "APP STORE",
        url: "https://sandbankapp.onelink.me/u9ZD/fb15e190",
        image: "/img/pages/main/apple.png"
      }
    ]
  },

  about_intro: {
    title: "Blockchain / WEB 3.0 Fintech Startup",
    img: "img/pages/main/company_logo.png",
    description:
      "DA:Ground creates digital asset financial services beyond borders.<br/>The internet revolution has connected us, however, the financial sector has been restrained by region and regulations and not been connected sufficiently yet.<br/>We are a tech-fin startup that actualizes 'connected finance' via blockchain and other new technologies. 'Sandbank' which is the newly presented crypto asset banking service by DA:Ground is the first step to this innovation.<br/>The Sandbank offers crypto asset investment services that are easily accessible to anyone beyond borders."
  },
  about_business: {
    title: "Business Area",
    items: [
      {
        title: "Sandbank",
        description: "Crypto investment/asset management service",
        img: "/img/pages/main/Value_1.jpg"
      },
      // {
      //   title: "SmashFi",
      //   description:
      //     "Web3.0 investment service based on global exchange partnership",
      //   img: "/img/pages/main/Value_2.jpg"
      // },
      {
        title: "B2B solution business",
        description:
          "Providing SI development and self-construction solutions related to STO / NFT (financial companies and global blockchain projects)<br/>Providing on/off-chain/related data and own index for B2B",
        img: "/img/pages/main/Value_3.jpg"
      },
      {
        title: "Blockchain consulting and education business",
        description:
          "Protocol design and tokenization consulting tailored to business needs<br/>Providing specialized blockchain training programs for companies and institutions",
        img: "/img/pages/main/Value_4.jpg"
      }
    ]
  },
  about_value: {
    title: "Core Value",
    items: [
      {
        img: "/img/pages/main/신뢰.png",
        title: "TRUST",
        description:
          "Our top priorities are transparency and honesty. We are creating a world of finance where everyone can confide in."
      },
      {
        img: "/img/pages/main/혁신.png",
        title: "INNOVATION",
        description:
          "We are always challenging to the next level. We are aimed to become a financial evangelist for everyone who seeks financial success."
      },
      {
        img: "/img/pages/main/전문성.png",
        title: "EXPERTISE",
        description:
          "We are pioneers in the crypto economics. Our team's profound analysis on the crypto market stands out among competitors."
      }
    ]
  },
  about_founder: {
    title: "Co-Founders",
    quote: "/img/pages/main/quote.png",
    items: [
      {
        img: "/img/pages/main/homepage-CEO.jpg",
        title: "CEO",
        name: "Jason Hyunmyung Lee",
        description:
          "“Jason is CEO and front-end engineer at DA:Ground. He designed and managed the derivatives trading system of Miraeasset Securities, Korea's largest investment bank, and later joined Coinone, the leading digital asset exchange in Korea, as one of the founding members. He has closely experienced the growth of both the traditional and digital asset banking industries.”",
        list: [
          "KAIST, Bachelor's in Computer Science",
          "Former) CGEX (Cryptocurrency Exchange), Chief Strategy Officer (CSO)",
          "Former) AI Startup COMMON COMPUTER. Project Advisor",
          "Former) Cryptocurrency Exchange COINONE, Strategy/BD Team Leader",
          "Former) Cryptocurrency Exchange COINONE, Planning/PM Team Leader",
          "Former) MIRAE Asset Securities, MTS Planning PM",
          "Former) MIRAE Asset Securities, Derivatives Business Design PM"
        ]
      },
      {
        img: "/img/pages/main/homepage-COO.jpg",
        title: "COO",
        co_founder: "Co-Founder",
        name: "Brian Hoonjong Paik",
        description:
          "“Brian is COO and head of sales and marketing at DA:Ground. He worked as a corporate sales manager at Sae-A Trading, the largest OEM garment manufacturer in Korea, and later moved to Coinone, the leading digital asset exchange in Korea to take a roll of institution sales manager and business developer. He has a deep understanding of overseas sales in many different industries.”",
        list: [
          "George Washington Univ, BA in Business Admin",
          "Former) Cryptocurrency Exchange COINONE, Corporate Sales Manager",
          "Former) Cryptocurrency Exchange COINONE, BD Manager",
          "Former) Sae-A International, Sales & Sourcing"
        ]
      },
      {
        img: "/img/pages/main/homepage-CIO.jpg",
        title: "CIO",
        co_founder: "Co-Founder",
        name: "Jungwun Kim",
        description:
          "“Jungwun is a strategist at DA:Ground, leading the strategy for its continuous growth. He worked as a business developer at Coinone, the leading digital asset exchange in Korea, and later joined its overseas subsidiary, CGEX, where he managed the overall corporate establishment strategy. At AI Network, a reputable blockchain project in Korea, he developed its token economy and growth strategy.”",
        list: [
          "Seoul National Univ, BA in Business Admin",
          "Former) Cryptocurrency Exchange CGEX, BD Manager",
          "Former) AI Startup Common Computer, PM",
          "Former) Cryptocurrency Exchange COINONE, BD Manager"
        ]
      },
      {
        img: "/img/pages/main/homepage-CTO.jpg",
        title: "CTO",
        co_founder: "Co-Founder",
        name: "Sujin Park",
        description:
          "“Sujin is CTO and a full-stack engineer at DA:Ground. He developed and managed the equity capital ledger and trading system at Miraeasset Securities, Korea’s largest investment bank. After joining Directional, a reputable fintech startup in Korea, he led the software engineering team that developed the P2P stock lending platform.”",
        list: [
          "Kookmin University, BA in Computer Engineering",
          "Former) Fintech Startup DIRECTIONAL, CTO",
          "Former) MIRAE Asset Securities, Trading System Development",
          "Former) MIRAE Asset Securities, Balance System Development"
        ]
      }
    ]
  },

  about_partner: {
    title: "Backed by leading partners",
    items: [
      {
        name: "PRIMER",
        image: "/img/pages/main/partner_primer_color.png",
        url: "https://primer.kr"
      },
      {
        name: "STRONG VENTURES",
        image: "/img/pages/main/partner_strong_color.png",
        url: "https://www.strongvc.com"
      },
      {
        name: "KICA",
        image: "/img/pages/main/partner_kica_color.png",
        url: "https://www.kica.co.kr/kica/main/formMain.sg"
      },
      {
        name: "GOOGLE FOR STARTUP",
        image: "/img/pages/main/partner_google_color.png",
        url: "https://www.campus.co/intl/ko_kr/seoul/"
      },
      {
        name: "CHAINLINK",
        image: "/img/pages/main/partner_chainlink_color.png",
        url: "https://chain.link"
      },
      {
        name: "HAECHI LABS",
        image: "/img/pages/main/partner_haechi_color.png",
        url: "https://haechi.io"
      },
      {
        name: "HEXLANT",
        image: "/img/pages/main/partner_hexlant_color.png",
        url: "https://hexlant.com"
      }
    ]
  },
  footer: {
    title: `DA Ground Co., Ltd.`,
    mail: "info@daground.io",
    policy: [
      {
        name: "Terms of use",
        text: "lorem",
        url: "https://sandbankofficial.notion.site/efcae7fc67b94d1aafc2c53168cf64e4"
      },
      {
        name: "Privacy Policy",
        text: "lorem",
        url: "https://sandbankofficial.notion.site/21a0613b314946759fb652150972ae1b"
      },
      {
        name: "Marketing Agreement",
        text: "lorem",
        url: "https://sandbankofficial.notion.site/ae8be83e0a4f47f08a522892c1335388"
      }
    ],
    social: [
      {
        name: "FACEBOOK",
        image: "/img/pages/footer/facebook.png",
        url: "https://www.facebook.com/sandbank.official"
      },
      {
        name: "TWITTER",
        image: "/img/pages/footer/twitter.png",
        url: "https://twitter.com/sandbank_kr/"
      },
      {
        name: "YOUTUBE",
        image: "/img/pages/footer/youtube.png",
        url: "https://www.youtube.com/channel/UC2tM460k4I6vSxktyDDkSsA"
      },
      {
        name: "BLOG",
        image: "/img/pages/footer/naverblog.png",
        url: "https://blog.naver.com/sandbank_official"
      },
      {
        name: "MEDIUM",
        image: "/img/pages/footer/medium.png",
        url: "https://medium.com/sandbank-kr"
      }
    ],
    info: "DA Ground Co., Ltd. | CEO Hyunmyung Lee | Registration No.190-88-01294",
    address:
      "34, Hakdong-ro 30-gil, Gangnam-gu, Seoul, South Korea, 2nd floor of Harim Building",
    copyright: "© Copyright 2019-2026 DAGROUND Inc. All Rights Reserved."
  },

  modal: {
    desktopImage: "/img/pages/modal/modal_sams_web.png",
    mobileImage: "/img/pages/modal/modal_sams_app.png",
    url: "https://medium.com/sandbank-kr/%EC%9E%90%EC%82%B0%EA%B4%80%EB%A6%AC-%EA%B8%B0%EB%8A%A5-%EC%8C%A4%EC%A6%88-sams-%EC%B6%9C%EC%8B%9C-%EC%95%88%EB%82%B4-cc02cd3f8481"
  },
  appInfo: [
    {
      id: 1,
      image: "/img/pages/main/main_info_1.png",
      title: "쉬워지는 크립토 자산관리",
      text: "어디에, 얼마나 갖고 있는지도 모르는 코인들 😰 <br /> 모두 샌드뱅크에 연동해서 한 번에 관리하세요"
    },
    {
      id: 2,
      image: "/img/pages/main/main_info_2.png",
      title: "캘린더로 정리하는 투자 내역",
      text: "내역을 수집해 캘린더로 깔끔하게 보여드려요 📅 <br /> 이제 손쉽게 과거 내역을 확인할 수 있습니다"
    },
    {
      id: 3,
      image: "/img/pages/main/main_info_3.png",
      title: "안전하게 경험하는 크립토 투자",
      text: "지갑 속에 잠자고 있는 내 코인들 😴 <br /> 샌드뱅크와 함께 매일 보상을 받아가세요"
    },
    {
      id: 4,
      image: "/img/pages/main/main_info_4.png",
      title: "놓칠 수 있는 소식 하나까지도",
      text: "매일 쏟아지는 크립토 시장 뉴스를 빠르게 확인하고 <br /> 실시간으로 알림을 받아보세요"
    },
    {
      id: 5,
      image: "/img/pages/main/main_info_5.png",
      title: "차곡차곡 쌓여가는 크립토 지식",
      text: "크립토 시장 동향, 리포트, 컬럼, 규제 등 <br /> 유용한 콘텐츠를 주제별로 골라 볼 수 있어요"
    }
  ]
};
